import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { MainHeadline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { NavButton, OrangeButton } from 'components/Button'
import { CalendarList } from 'components/List'
import { useDispatch } from 'react-redux'
import { openModal } from 'reducks/modal/operations'
import { HolidayCalendarContainer } from 'components/Calendar'

const CalendarsTemplate: FC = () => {
  const dispatch = useDispatch()

  const openCalendarModal = useCallback(() => {
    dispatch(openModal(<HolidayCalendarContainer />, '祝日を選択してください'))
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'祝日の設定'} />
      <Spacer size={28} />
      <OrangeButton
        iconPath={'/icon/white/calendar.svg'}
        label={'祝日を設定する'}
        onClick={openCalendarModal}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <MainHeadline headline={'設定中の祝日'} />
      <Spacer size={28} />
      <CalendarList />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CalendarsTemplate
